export enum Themes {
    VITA_STUDENT = 'vs',
    HOUSE_OF_SOCIAL = 'hos',
}
